import React, { useEffect, useRef, useState } from 'react';
import { Grid, TextField, Typography } from '@material-ui/core';
import CustomToolTip from '../common/CustomToolTip';
import EditIcon from '@material-ui/icons/Edit';
import { useDispatch } from 'react-redux';
import { updateAsset } from '../../redux/actions/manageAssetActions';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import { openErrorSnackBar } from '../../redux/actions/snackBarActions';

const useStyles = makeStyles((theme) => ({
	subtitle: {
		color: theme.palette.neutral.n400,
		textTransform: 'uppercase',
	},
	textBox: {
		width: '100%',
	},
	root: {
		flexGrow: 1,
		padding: '1em',
		backgroundColor: '#F5F5F5',
		'& > *': {
			margin: theme.spacing(1),
		},
	},
}));
const FieldValTypography = ({ val }) => {
	return (
		<Typography variant="body1" display="initial">
			{val}
		</Typography>
	);
};
const EditableNameTxt = ({ asset, setEditable }) => {
	const assetNameTxt = useRef(null);
	const classes = useStyles();
	const [val, setVal] = useState(asset.name);
	const dispatch = useDispatch();
	useEffect(() => {
		// set the focus on the text box in edit mode.
		assetNameTxt.current.getElementsByTagName('input')[0].focus();
	}, []);
	const handleChange = (event) => {
		const name = event.target.value;
		setVal(name);
	};
	const handleBlur = () => {
		// only update when asset name is changed.
		if (val !== asset.name) {
			if (val.length > 0) {
				const updatedAsset = { ...asset, name: val };
				dispatch(updateAsset(updatedAsset));
			} else {
				dispatch(openErrorSnackBar('Asset name cannot be empty'));
			}
		}
		setEditable(false);
	};
	return (
		<TextField
			id="asset-name-editable-txt"
			className={classes.textBox}
			variant="outlined"
			color="primary"
			value={val}
			onChange={handleChange}
			onBlur={handleBlur}
			ref={assetNameTxt}
			size="small"
		/>
	);
};

const AssetNameInput = ({ asset }) => {
	const [isEditable, setEditable] = useState(false);
	const classes = useStyles();
	if (isEditable) {
		return <EditableNameTxt asset={asset} setEditable={setEditable} />;
	}

	return (
		<div data-cy="asset-name">
			<Typography className={classes.subtitle} variant="subtitle1" display="initial">
				ASSET NAME
			</Typography>
			<Grid container>
				<Grid item xs={1}>
					<CustomToolTip
						title={'Click here to edit name'}
						InnerComponent={
							<IconButton
								className={classes.editButton}
								color="primary"
								size="small"
								onClick={() => setEditable(true)}
							>
								<EditIcon />
							</IconButton>
						}
					/>
				</Grid>
				<Grid item xs={11}>
					<FieldValTypography val={asset.name} className={classes.root} />
				</Grid>
			</Grid>
		</div>
	);
};

export default AssetNameInput;
